import { FC, JSX, ReactNode } from 'react';
import styles from './Navigator.scss';
import classNames from 'classnames';

type NavigatorProps = JSX.IntrinsicElements['div'] & {
  isOpen?: boolean;
  children: ReactNode;
};

export const Navigator: FC<NavigatorProps> = ({ className, children, ...divProps }) => {
  return (
    <div {...divProps} className={classNames(styles.navigator, className)}>
      {children}
    </div>
  );
};

type HeaderProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Header: FC<HeaderProps> = ({ className, children, ...divProps }) => {
  return (
    <div {...divProps} className={classNames(styles.header, className)}>
      {children}
    </div>
  );
};

type BodyProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Body: FC<BodyProps> = ({ className, children, ...divProps }) => {
  return (
    <div {...divProps} className={classNames(styles.body, className)}>
      {children}
    </div>
  );
};

type ItemProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Item: FC<ItemProps> = ({ className, children, ...divProps }) => {
  return (
    <div {...divProps} className={classNames(styles.item, className)}>
      {children}
    </div>
  );
};
